import i18n from '~/translations';

export const SECTION = {
  INTERACTION: 'INTERACTION',
  WAITING_CONDITIONS: 'WAITING_CONDITIONS',
  EXECUTION: 'EXECUTION',
  SCREENSHOTS: 'SCREENSHOTS',
} as const;

export const SECTION_LABEL = {
  [SECTION.SCREENSHOTS]: i18n.t('stepDetails.tabs.screenshots.label', 'Screenshots'),
  [SECTION.INTERACTION]: i18n.t('stepDetails.tabs.interaction.label', 'Interaction'),
  [SECTION.EXECUTION]: i18n.t('stepDetails.tabs.execution.label', 'Execution'),
  [SECTION.WAITING_CONDITIONS]: i18n.t(
    'stepDetails.tabs.waitingConditions.label',
    'Waiting Conditions',
  ),
} as const;

export const SECTION_DESCRIPTION = {
  [SECTION.WAITING_CONDITIONS]: i18n.t(
    'stepDetails.tabs.waitingConditions.description',
    'Some waiting conditions are by default inherited from project settings. You can override the global settings for each step.',
  ),
} as const;

export const WAITING_CONDITION_STATE = {
  DEFAULT: 'DEFAULT',
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
} as const;

export const SAVE_ACTION_TYPE = {
  SAVE: 'SAVE',
  SAVE_AND_CLOSE: 'SAVE_AND_CLOSE',
} as const;

export const STEP_UNSAVED_CHANGES = i18n.t(
  'stepDetails.unsavedChangesPrompt',
  'You have unsaved changes. Are you sure to leave this page?',
);
